/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LORAX } from 'HubStyleTokens/colors';
import UISelectableButton from 'UIComponents/button/UISelectableBox';
import UIIcon from 'UIComponents/icon/UIIcon';
import Branding from 'MeetingsBase/models/Branding';
import { getColorStyleWithOpacity } from 'MeetingsLib/utils/color';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import SafeStorage from 'SafeStorage';
import FreemiumViralTrackingPixel from 'MeetingsLib/tracking/FreemiumViralTrackingPixel';
export default class FreemiumUpgradeButton extends Component {
  constructor(...args) {
    super(...args);

    this.generateRandomIdentifier = param => {
      const storedExperimentIdentifier = `${param}-exp-id`;
      let random = SafeStorage.getItem(storedExperimentIdentifier);

      if (!random) {
        random = Math.random();
        SafeStorage.setItem(storedExperimentIdentifier, random);
      }

      return random;
    };

    this.handleTreatmentFetched = () => {
      this.setState({
        treatmentFetched: true
      });
    };

    this.handleViralButtonClick = () => {
      if (this.state.experimentEnabled) {
        track('meetingsLibViralityExperiment', {
          action: 'click',
          variation: this.state.variation
        });
      }

      this.props.handleButtonClick();
    };

    this.getBrandingActiveStyle = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;

      if (!primaryColor) {
        return null;
      }

      return {
        width: 'auto',
        borderColor: primaryColor,
        backgroundColor: getColorStyleWithOpacity(primaryColor)
      };
    };

    this.getBrandingTextStyle = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;

      if (!primaryColor) {
        return null;
      }

      return {
        color: primaryColor
      };
    };
  }

  componentDidMount() {
    track('meetingsViralityPageView', {
      action: 'virality-thank-you-page-view'
    });
    this.handleTreatmentFetched();
  }

  render() {
    const {
      handleButtonClick,
      portalId,
      embedded
    } = this.props;
    const linkType = 'meetings-thankyou';
    return /*#__PURE__*/_jsxs(UISelectableButton, {
      padded: false,
      selected: false,
      className: "freemium-advert-button",
      style: this.getBrandingActiveStyle(),
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onClick: handleButtonClick,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "sprocket",
        color: LORAX,
        className: "m-right-1"
      }), /*#__PURE__*/_jsx("span", {
        style: this.getBrandingTextStyle(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.meetingsAdvert.freemium"
        })
      }), portalId > -1 && /*#__PURE__*/_jsx(FreemiumViralTrackingPixel, {
        portalId: portalId,
        embedded: embedded,
        viralLinkType: linkType
      })]
    });
  }

}
FreemiumUpgradeButton.propTypes = {
  handleButtonClick: PropTypes.func.isRequired,
  branding: PropTypes.instanceOf(Branding).isRequired,
  portalId: PropTypes.number.isRequired,
  embedded: PropTypes.bool
};